<template>
    <!-- 这是添加用户区域 -->
    <div  class="centerUser">
      <el-container>
        <el-header>{{$t('message.注册用户')}}</el-header>
        <el-main>
          <!-- <div class="welcome">欢迎注册新用户</div> -->
          <div style="padding-left:50px">
            <el-steps :active="active" finish-status="success" align-center simple="">
            <el-step :title="$t('message.账号验证')"></el-step>
            <el-step :title="$t('message.个人信息')"></el-step>
            <el-step :title="$t('message.验证码和确认提交')"></el-step>
            <el-step :title="$t('message.完成')"></el-step>
          </el-steps>
          </div>
          <div class="formList">
              <el-form  :model="form" label-width="80px" :rules="rules" ref="ruleForm1" v-if="active==1" @submit.native.prevent>
            <el-form-item :label="$t('message.账号')" prop="loginID" >
              <el-input v-model="form.loginID" ></el-input>
            </el-form-item>
          </el-form>
          <el-form  :model="form" label-width="80px" :rules="rules" ref="ruleForm2" v-if="active==2" @submit.native.prevent>
            <el-form-item :label="$t('message.姓名')" prop="name" v-if="active==2">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('message.工作名')" prop="workname" v-if="active==2">
              <el-input v-model="form.workname"></el-input>
            </el-form-item>
            <el-form-item :label="$t('message.性别')" v-if="active==2">
              <el-radio v-model="form.sex" label="0">{{$t('message.保密')}}</el-radio>
              <el-radio v-model="form.sex" label="1">{{$t('message.男')}}</el-radio>
              <el-radio v-model="form.sex" label="2">{{$t('message.女')}}</el-radio>
            </el-form-item>
          </el-form>
          <el-form  :model="form" label-width="80px" :rules="rules" ref="ruleForm3" v-if="active==3" @submit.native.prevent>
            <el-form-item :label="$t('message.电话')" prop="tel" v-if="active==3">
              <div style="display:flex;">
              <el-select :placeholder="$t('message.请选择地区')" filterable v-model="phone_code" clearable @change="selectedPhone">
                <el-option
                  v-for="item in this.countryCode"
                  :key="item.english_name"
                  :label="item.chinese_name+' +'+item.phone_code"
                  :value="item.phone_code">
                </el-option>
                <span></span>
              </el-select>
              <el-input v-model="form.tel" :placeholder="$t('message.请输入电话号码')"></el-input>
              </div>
            </el-form-item>
            <el-form-item :label="$t('message.验证码')" prop="confirmCode" v-if="active==3">
              <div style="display:flex">
                  <el-input v-model="form.confirmCode" width='200'/>
                  <el-button @click="getCode" :disabled='codeable' size="mimi">{{$t('message.获取验证码')}}</el-button>
              </div>
                  <span v-if="time>1">{{time==60?'':time+$t('message.秒后再次获取验证码')}}</span>
            </el-form-item>
          </el-form>
          <div v-if="active==4">
            <el-form  :model="form" label-width="200px"  @submit.native.prevent>
            <el-form-item :label="$t('message.注册账号成功')">
               <h1>{{$t('message.登录账号')+this.form.loginID+$t('message.默认密码')+'888888'}}</h1>
            </el-form-item>
          </el-form>
          </div>
          </div>
        </el-main>
        <el-footer>
              <el-button type="info"  @click="resetForm('ruleForm3')">{{active==4?$t('message.退出'):$t('message.取消')}}</el-button>
              <el-button type="primary"  @click="prevent" v-if='active!=1&&active!=4' >{{$t('message.上一步')}}</el-button>
              <el-button type="primary"  @click="next('ruleForm'+active)" v-if='active<3' >{{$t('message.下一步')}}</el-button>
              <el-button type="info"  @click="resagin" v-if="active==4">{{$t('message.再次注册')}}</el-button>
              <el-button type="primary"  @click="submitForm('ruleForm3')" v-if="active==3">{{$t('message.确认注册')}}</el-button>
        </el-footer>
      </el-container>
    </div>
</template>

<script>
import {rejecthttp,changeflagCLOSED} from "@/utils/request";
import countryCode from '@/assets/fronttelphone'
export default {
  name: "register",
  props: ['searchContent'],
  data() {
    return {
      active:1,
      form:{
        loginID:'',
        name:'',
        workname:'',
        tel:'',
        sex:'0',
        confirmCode:''
      },
      handleID:'',
      codeable:false,
      time:60,
      rules:{
        name:[{ required: true, message: this.$t('message.请输入名字'), trigger: 'blur' },],
        tel:[{ required: true, message: this.$t('message.请输入有效的电话号码'), trigger: 'blur' },],
        confirmCode:[{ required: true, message: this.$t('message.请输入验证码'), trigger: 'blur' },],
        loginID:[{ required: true, message: this.$t('message.请输入账号名'), trigger: 'blur' },
        {
            validator: this.loginIDConfirm,
            message: this.$t('message.账号名长度'),
            trigger: "blur",
          },
        ],
      },
      pass:false,
      dialogVisible:false,
      countryCode,
      phone_code:''
    };
  },

  methods: {
    selectedPhone(){
      console.log(this.phone_code);
    },
    prevent(){
      if(this.active>1){
        this.active--
      }
    },
    next(formName){
       this.$refs[formName].validate((valid) => {
          console.log(valid);
          if (valid) {
           if(this.active<4){
              this.active++
            }
          } else {
            return false;
          }
        });
    },
    async loginIDConfirm(v,c,callback){
      var matc=/^\w{3,36}$/
      var loginc
      try{
         loginc= await this.$http.get("/manage/account/checkloginid", {params:{
        loginID:this.form.loginID
      }})
      console.log(loginc.data);
      if (loginc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }else{
            // this.pass=false
          }
      }catch(e){

      }
      console.log(loginc);
      if (!matc.test(this.form.loginID)||loginc.data.Code != "MSGKEY_OK") {
        //显示错误提示
        this.pass=true
        if (callback) callback(false);
        return false;
      }
      return true;
    },
    submitForm(formName) {
      let submit =true
      var that=this
        this.$refs[formName].validate((valid) => {
          console.log(valid);
          if (valid) {
          } else {
            submit=false
            console.log(valid);
            console.log('error submit!!');
            return false;
          }
        });
        if(submit){
            var sendData={handleID:this.handleID,loginID:this.form.loginID,mobile:this.form.tel,
            gender:this.form.sex,
            name:this.form.name,smsCode:this.form.confirmCode,workInfo:{
              appid:188,
              backaccountid: 0,
              contact: "",
              createdate: "",
              createid: 0,
              editdate: "",
              editid: 0,
              remark: "",
              state: 0,
              workname: this.form.workname
            }}
            that.$http
        .post("/manage/account/registerforemployee", sendData).then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            if(doc.data.Code=='MSGKEY_OK'){
                console.log(6789);
            this.active=4
            }
          }
        });
        }
      },
      resetForm(formName) {
          console.log(564758);
        this.$emit('disVisble')
        // this.$refs[formName].resetFields();
      },
      resagin(){
          this.active=1
      },
    // 获取验证码
    getCode(){
      var that =this
      rejecthttp(false,'get',"/manage/account/getsmscode",{
            appid: "188",
            mobile: this.form.tel,
            type:'registerforemployee'
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.codeable=true
            console.log(doc.data);
            this.handleID=doc.data.data
            var that=this
            console.log(that.handleID);
            var interval=setInterval(()=>{
                that.time--
              },1000)
            setTimeout(() => {
              that.codeable=false
              that.time=60
              clearInterval(interval)
            }, 60000);
            }
            })
      // this.$http
      //   .get("/manage/organization/employee/getsmscode", {
      //     params: {
      //       appid:188,
      //       mobile: this.form.tel,
      //     },
      //   }).then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       that.codeable=true
      //       console.log(doc.data);
      //       that.handleID=doc.data.data
      //       console.log(that.handleID);
      //       var interval=setInterval(()=>{
      //           that.time--
      //         },1000)
      //       setTimeout(() => {
      //         that.codeable=false
      //         that.time=60
      //         clearInterval(interval)
      //       }, 60000);
      //     }
      //   });
    },
    // 添加用户
    adduser(){
      console.log(this.searchContent);
      this.form.tel=this.searchContent
      // this.onCancelChoseAccount()
     this.dialogVisible=true
    //  shade.click()
      // 关闭搜索框
    },
  },

  computed: {},
  created() {},
  mounted() {
    console.log(this.countryCode);
    console.log(this.searchContent);
    this.form.tel=this.searchContent
    // var shade=document.querySelector('.shade')
    // shade.style.zIndex='2000'
    // var center=shade.querySelector('.center')
    // center.style.zIndex='1999'
  },
  destroyed(){
    // var shade=document.querySelector('.shade')
    // shade.style.zIndex='5999'
    // var center=shade.querySelector('.center')
    // center.style.zIndex='3000'
  }
};
</script>

<style scoped>
.formList{
  margin: auto;
  height: 400px;
  padding: 50px 100px 0 100px;
  background-image: url('../../assets/img/logo.a13e.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.welcome{
  font-size: 44px;
  margin-bottom: 20px;
}
.centerUser{
  position: absolute;
  width: 1050px;
  height: 720px;
  top: 50%;
  left: 50%;
  background-color: #F8F8F8;
  border: 1px solid #303133;
  z-index: 2001;
  transform: translate(-50%,-50%);
}
.el-header, .el-footer {
    color: #333;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    line-height: 60px;
  }
  .el-footer{
    text-align: right;
    background-color: #E9EEF3;
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    height: 598px;
    font-size: 18px;
    text-align: left;
  }
  .el-main input{
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue